import { IEnvironment } from './environment.interface';

export const environment: IEnvironment = {
  production: true,
  devTool: false,
  baseUrls: {
    serviceSecurity: 'https://thermofisher.siliconexpert.com',
        serviceURL: 'https://thermofisher.siliconexpert.com/api/v1',
    },
  ConfigParams: {
        infoUserEmail: 'adriana.nelson@thermofisher.com',
        infouser: 'Adriana Nelson',
        projectName:'ThermoFisher',
        domain:'https://thermofisher.siliconexpert.com'
    },
  powerBiReports: {
    dashboardReportId: '4c92e06a-a325-4629-a31b-d9773e5439e5',
  },
  session: {
    idleTimeoutSeconds: 900,  // 15 minutes
    warningTimeoutSeconds: 120  // Show warning 120 seconds before logout

  }
};
